// src/directives/validateCharset.ts
import { validateUtf8mb4 } from '@/utils/validateCharset';

export const vValidateCharset = {
  mounted(el: HTMLElement) {
    el.addEventListener('input', (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (!validateUtf8mb4(target.value)) {
        // 提示警告（可替换为 UI 框架的弹窗）
        alert('输入包含无效字符（如控制符）！');
        // 自动清理非法字符
        target.value = target.value.replace(/[\p{C}]/gu, '');
      }
    });
  },
};